/**
 * Shared display helpers for `limit_metric_types` / `plan_limit_definitions` data,
 * used by both the admin plan-limits editor and the enrollee consumption view so
 * the two don't drift into separate re-implementations of the same badge/tooltip logic.
 * See docs/LIMIT_METRIC_TYPES_INTEGRATION.md for the underlying contract.
 */

export const metricTagColor = (slug) => {
  if (slug === 'monetary') return 'blue';
  if (slug === 'count') return 'green';
  if (slug === 'days') return 'orange';
  return 'default';
};

export const CALCULATION_RULE_DESCRIPTIONS = {
  sum_approved_cost: 'Total ₦ of approved claim items',
  count_distinct_visits: 'Number of unique checkins',
  date_diff_bed_nights: 'Number of nights from admission to discharge',
  count_events: 'Number of encounters/sessions',
  count_claim_items: 'Number of individual claim items',
};

export const calculationRuleDescription = (rule) => CALCULATION_RULE_DESCRIPTIONS[rule] || null;

/**
 * The `_granular` consumption rows have no `target_label` yet (backend gap —
 * see BACKEND_REQUIREMENTS_PA_RESERVATION_LEDGER.md). Derive a readable
 * fallback from target_type/target_id until the backend adds one; prefer
 * `row.target_label` over this wherever it's present.
 */
export const resolveGranularTargetLabel = (row) => {
  if (row?.target_label) return row.target_label;
  const type = row?.target_type;
  if (!type || type === 'plan') return 'Plan-wide';
  const id = row?.target_id;
  if (type === 'category') return id != null ? `Category #${id}` : 'Category';
  if (type === 'subcategory') return id != null ? `Subcategory #${id}` : 'Subcategory';
  if (type === 'item') return id != null ? `Item #${id}` : 'Item';
  return String(type);
};
